<div class="container p-4">
    <div class="card border-0 shadow-sm mb-3 py-1 px-4">
        <dx-toolbar class="theme-dependent">
            <dxi-item location="before">
                <div class="header-text">{{ incidentId ? 'Edit' : 'New' }}</div>
            </dxi-item>
            <dxi-item location="after" locateInMenu="never" [visible]="!isReadOnly">
                <dx-button text="Cancel" stylingMode="outlined" type="normal" (onClick)="cancel()">
                </dx-button>
            </dxi-item>
            <dxi-item location="after" locateInMenu="never" [visible]="!isReadOnly">
                <dx-button text="Submit" icon="save" type="default" stylingMode="contained"
                           [disabled]="isSubmitting" (onClick)="save()">
                </dx-button>
            </dxi-item>
            <dxi-item location="after" locateInMenu="never" [visible]="showApproveButton">
                <dx-button text="Approve" type="success" stylingMode="contained" [disabled]="isSubmitting"
                           (onClick)="save(true)">
                </dx-button>
            </dxi-item>
        </dx-toolbar>
    </div>

    <dx-load-panel container=".view-wrapper-scroll" [visible]="isLoading" [showPane]="false"
                   [position]="{ of: 'incident-report-details' }">
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll" height="80vh">
        <dx-validation-group #validationGroup>
            @if (!isLoading) {
                <div class="form-container">
                    <div class="card border-0 shadow-sm pt-0 mb-4">
                        <div class="card-header fs-5 fw-medium">Incident Details</div>
                        <div class="card-body">
                            @if (incidentId) {
                                <div class="form-section">
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <user-avatar-email [email]="incidentReport.createdBy?.email"
                                                               [name]="incidentReport.createdBy?.name"
                                                               [avatarUrl]="incidentReport.createdBy?.avatarUrl"></user-avatar-email>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="d-flex">
                                                <strong class="me-2">Date Submitted:</strong>
                                                <span>{{ incidentReport.created | date: dateTimeFormat }}</span>
                                            </div>
                                            <div class="d-flex">
                                                <strong class="me-2">Status: </strong>
                                                <span class="badge" [ngClass]="getBadgeClass(incidentReport.status)">
                                                    {{ incidentReport.status?.toString() | capitalCase }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="d-flex">
                                                <strong class="me-2">Last Updated:</strong>
                                                <span>{{ incidentReport.lastModified | date: dateTimeFormat }}</span>
                                            </div>
                                            <div class="d-flex">
                                                <strong class="me-2">Updated By:</strong>
                                                <span>{{ incidentReport.lastModifiedBy }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            <div class="form-section" [class.mt-4]="incidentId">
                                <app-classification-section [incidentReport]="incidentReport" [isReadOnly]="isReadOnly"
                                                            [yesOrNoOptions]="yesOrNoOptions" [validateYesNo]="validateYesNo">
                                </app-classification-section>
                            </div>
                            <hr>
                            <div class="form-section mt-3">
                                <app-employee-incident-details [incidentReport]="incidentReport"
                                                               [employeesDataSource]="employeesDataSource"
                                                               [shiftDataSource]="shiftDataSource"
                                                               [isReadOnly]="isReadOnly" [yesOrNoOptions]="yesOrNoOptions"
                                                               [validateYesNo]="validateYesNo"
                                                               [selectedEmployeeId]="incidentReport.employeeId">
                                </app-employee-incident-details>
                            </div>
                            <hr>
                            <div class="form-section mt-3">
                                <app-witnesses-section [incidentReport]="incidentReport"
                                                       [employeesDataSource]="employeesDataSource" [isReadOnly]="isReadOnly">
                                </app-witnesses-section>
                            </div>
                            <hr>
                            <div class="form-section mt-3">
                                <app-activity-section [incidentReport]="incidentReport"  [isReadOnly]="isReadOnly">
                                </app-activity-section>
                            </div>
                            <hr>
                            <div class="form-section mt-3">
                                <app-events-sequence-section [incidentReport]="incidentReport" [isReadOnly]="isReadOnly">
                                </app-events-sequence-section>
                            </div>
                            <hr>
                            <div class="form-section mt-3">
                                <div class="header-text">At-Risk Conditions / Systems Analysis</div>
                                <div class="mb-4 mt-3">
                                    <label class="form-label">1) Equipment issues (broken, sharp-edged,
                                        missing guards, etc. Include manufacturer if applicable)</label>
                                    <dx-text-area [(value)]="incidentReport.equipmentIssues" stylingMode="filled"
                                                  [height]="80" placeholder="Enter equipment issues details..." [maxLength]="2000"
                                                  [readOnly]="isReadOnly">
                                    </dx-text-area>
                                </div>
                                <div class="mb-4 mt-3">
                                    <label class="form-label">2) Environmental or business systems that
                                        contributed (weather, housekeeping, time restraints, lighting, noise, etc.)</label>
                                    <dx-text-area [(value)]="incidentReport.environmentalFactors" stylingMode="filled"
                                                  [height]="80" placeholder="Enter environmental factors details..."
                                                  [maxLength]="2000" [readOnly]="isReadOnly">
                                    </dx-text-area>
                                </div>
                            </div>
                            <hr>
                            <div class="form-section mt-3">
                                <div class="header-text">Root Cause (5 Whys)</div>
                                <div class="row g-3 mt-1">
                                    <div class="col-md-6">
                                        <label class="form-label">Basic Causes:</label>
                                        <dx-text-area [(value)]="incidentReport.basicCauses" stylingMode="filled"
                                                      [height]="80" placeholder="Enter basic causes details..." [maxLength]="2000"
                                                      [readOnly]="isReadOnly">
                                        </dx-text-area>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Root Cause:</label>
                                        <dx-text-area [(value)]="incidentReport.rootCause" stylingMode="filled"
                                                      [height]="80" placeholder="Enter root cause details..." [maxLength]="2000"
                                                      [readOnly]="isReadOnly">
                                        </dx-text-area>
                                    </div>
                                </div>
                                <div class="mt-4">
                                    <label class="form-label">Suggested solutions to eliminate/minimize future
                                        occurrences:</label>
                                    <dx-text-area [(value)]="incidentReport.suggestedSolution" stylingMode="filled"
                                                  [height]="80" placeholder="Enter suggested solutions details..." [maxLength]="2000"
                                                  [readOnly]="isReadOnly">
                                    </dx-text-area>
                                </div>
                            </div>
                            <hr>
                            <div class="form-section mt-3">
                                <app-root-cause-actions-section [incidentReport]="incidentReport"
                                                                [isReadOnly]="isReadOnly">
                                </app-root-cause-actions-section>
                            </div>
                        </div>
                    </div>
                    @if (incidentId) {
                        <app-compliance-manager-section [incidentReport]="incidentReport" [isReadOnly]="isReadOnly"
                                                        [yesOrNoOptions]="yesOrNoOptions">
                        </app-compliance-manager-section>
                    }

                    <app-notes
                        [entityId]="incidentId"
                        [noteType]="NoteType.IncidentReport"
                        [canCreate]="true"
                    ></app-notes>
                </div>
            }
        </dx-validation-group>
        @if (incidentId) {
            <app-approvals-section [incidentReport]="incidentReport"></app-approvals-section>
        }
    </dx-scroll-view>
</div>
